import {AccountBriefRecord, AccountBriefRecords} from "../../../../types/AccountBriefRecord";
import {UnaryTransform} from "../../../../../types/GenericTypes";
import {StringUtil} from "../../../../../js/util/StringUtil";

export type AccountSearchViewModels = ReadonlyArray<AccountSearchViewModel>;

export interface AccountSearchViewModel extends AccountBriefRecord {
    readonly display: string;
}

export class AccountSearchResultRankModel {

    constructor(public readonly record: AccountSearchViewModel,
                public readonly numberRank: number,
                public readonly nameRank: number) {
    }

    public get rank(): number {
        return Math.max(this.numberRank, this.nameRank);
    }
}

export function buildModels(records: AccountBriefRecords): AccountSearchViewModels {
    return records.map((r) => buildModel(r));
}

export function buildModel(record: AccountBriefRecord): AccountSearchViewModel {
    const display = `${record.number} - ${record.name}`;
    return Object.assign({}, record, {display});
}

export function orderModels(filter: string | null): UnaryTransform<AccountSearchViewModels> {

    return (models) => {
        return models.map((record) => calculateRank(record, filter))
                     .sort(orderByRank)
                     .map((rank) => rank.record);
    };
}

function calculateRank(record: AccountSearchViewModel, filter: string | null): AccountSearchResultRankModel {
    if (filter == null || filter === "") {
        return new AccountSearchResultRankModel(record, 0, 0);
    } else {

        const accountNumber = record.number;
        const numberMatchIndex = accountNumber.indexOf(filter);
        const matchesAccountNumber = numberMatchIndex >= 0;
        const numberPercentMatch = (filter.length / accountNumber.length);
        const accountNumberStartsWith = numberMatchIndex === 0 || (numberMatchIndex === 1 && StringUtil.isAlpha(accountNumber[0]));
        const accountNumberEndsWith = accountNumber.length === numberMatchIndex + filter.length;
        const startsWithBoost = (filter.length > 1 && accountNumberStartsWith) ? 0.2 : 0;
        const endsWithBoost = (filter.length > 1 && accountNumberEndsWith) ? 0.1 : 0;

        const numberRank = matchesAccountNumber ? Math.min(1, numberPercentMatch + startsWithBoost + endsWithBoost) : 0;

        const accountName = record.name;
        const accountNameMatchIndex = accountName.indexOf(filter);
        const matchesAccountName = accountNameMatchIndex >= 0;
        const nameRank = matchesAccountName ? filter.length / accountName.length : 0;

        return new AccountSearchResultRankModel(record, numberRank, nameRank);
    }
}

function orderByRank(a: AccountSearchResultRankModel, b: AccountSearchResultRankModel) {
    const rankDiff =  b.rank - a.rank;
    if (rankDiff === 0) {
        return rankDiff;
    } else {
        return orderByNumber(a.record, b.record);
    }
}

function orderByNumber(a: AccountSearchViewModel, b: AccountSearchViewModel): number {
    return a.number.localeCompare(b.number);
}

function orderByName(a: AccountSearchViewModel, b: AccountSearchViewModel): number {
    return a.name.localeCompare(b.name);
}
